export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const TIME_FILTER_OPTIONS = Object.freeze({
  year: { id: "year", label: "Year" },
  month: { id: "month", label: "Month" },
  last_week: { id: "last_week", label: "Last 7 days" },
} as const);

export const EARNINGS_DATA_KEYS = Object.freeze({
  [TIME_FILTER_OPTIONS.year.id]: "earnings_months",
  [TIME_FILTER_OPTIONS.month.id]: "earnings_weeks",
  [TIME_FILTER_OPTIONS.last_week.id]: "earnings_days",
} as const);

export type TTimeFilterType = keyof typeof TIME_FILTER_OPTIONS;

export const EARNINGS_DATA_TIMEZONE = "UTC";
